/**
 * Where the admin API is mounted. In its own module because both `client.ts` (every JSON call)
 * and `sso.ts` (the backend sign-in redirect) need it, and `client.ts` imports `sso.ts` — so
 * defining it in either would create an import cycle.
 */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "/admin";
